import styled from 'styled-components';
import { EllipsisWithLineClamp } from '@simplywallst/ui-core';
import { OpenNewWindowOutline } from '@simplywallst/ui-core/icons';
import { SubSectionHeader } from '@/pages/CompanyReport/components/Overview/components/SubSectionHeader';
import { media } from '@simplywallst/ui-core';

export const Table = styled('table')`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  border-spacing: 0;
  margin-left: -1px;

  thead th {
    ${(props) => props.theme.typography.xSmall}
    color: ${(props) => props.theme.color.whiteRGBA(0.7)};
    text-align: left;
  }
  tbody td {
    ${(props) => props.theme.typography.smallStrong}
    color: ${(props) => props.theme.color.white};
    text-align: left;
  }
`;

interface Props {
  clamped?: boolean;
}
export const Body = styled('p')<Props>`
  ${(props) => props.theme.typography.small}
  color: ${(props) => props.theme.color.white};
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  ${(props) => {
    if (props.clamped) {
      return EllipsisWithLineClamp(2);
    }
  }};
`;

export const OpenNewWindowIcon = styled(OpenNewWindowOutline)`
  path {
    fill: ${(props) => props.theme.color.brand01};
  }
  display: inline-block;
  vertical-align: bottom;
  width: 20px;
  height: 20px;
  margin-left: 6px;
  margin-bottom: 2px;
`;

export const Header = styled(SubSectionHeader)`
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  ${media.mdDown`
    ${({ theme }) => theme.typography.baseStrong};
  `};
`;
